export class AppSettings {
    constructor(public version: string, 
                public adminMenu: boolean,
                public locale: string,
                public rtl: boolean,
                public showLeftMenu: boolean,
                public rootUrl: string) { }
}